import React from 'react'
import { Card, CardContent, Typography, Box, useTheme } from '@mui/material'
import { TrendingUp, TrendingDown } from '@mui/icons-material'

const StatCard = ({ title, value, color, icon, trend, subtitle }) => {
  const theme = useTheme()
  
  const getColor = () => {
    const colors = {
      primary: theme.palette.primary.main,
      secondary: theme.palette.secondary.main,
      success: theme.palette.success.main,
      warning: theme.palette.warning.main,
      error: theme.palette.error.main,
      info: theme.palette.info.main
    }
    return colors[color] || theme.palette.primary.main
  }

  return (
    <Card 
      sx={{ 
        height: '100%',
        transition: 'all 0.2s',
        '&:hover': {
          transform: 'translateY(-4px)',
          boxShadow: theme.shadows[8]
        }
      }}
    >
      <CardContent>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 2 }}>
          <Box>
            <Typography variant="body2" color="text.secondary" gutterBottom>
              {title}
            </Typography>
            <Typography variant="h4" fontWeight={700} sx={{ color: getColor() }}>
              {typeof value === 'number' ? value.toLocaleString() : value}
            </Typography>
            {subtitle && (
              <Typography variant="caption" color="text.secondary">
                {subtitle}
              </Typography>
            )}
          </Box>
          <Box
            sx={{
              backgroundColor: `${getColor()}15`,
              borderRadius: '12px',
              width: 48,
              height: 48,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: getColor()
            }}
          >
            {icon}
          </Box>
        </Box>
        
        {trend !== undefined && (
          <Box sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
            {trend > 0 ? (
              <TrendingUp sx={{ fontSize: 16, color: theme.palette.success.main, mr: 0.5 }} />
            ) : (
              <TrendingDown sx={{ fontSize: 16, color: theme.palette.error.main, mr: 0.5 }} />
            )}
            <Typography
              variant="caption"
              sx={{ 
                color: trend > 0 ? theme.palette.success.main : theme.palette.error.main,
                fontWeight: 500
              }}
            >
              {Math.abs(trend)}% {trend > 0 ? 'increase' : 'decrease'} from last month
            </Typography>
          </Box>
        )}
      </CardContent>
    </Card>
  )
}

export default StatCard